import React from 'react'
import { Toaster } from 'sonner'
import { AuthProvider } from '@/providers/AuthContext'
import { PopupProvider } from '@/providers/PopupContext'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { HOMEPAGE_PATH } from '@/constants/variables'
import { ROUTES } from '@/constants/routes'
import { HomePage } from '@/components/pages/HomePage/HomePage'
import { RestrictedRoute } from '@/components/RestrictedRoute'
import LoginPage from '@/components/pages/LoginPage'
import OtpPage from '@/components/pages/OtpPage'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import ProfilePage from '@/components/pages/ProfilePage'
import ReasonsPage from '@/components/pages/ReasonsPage'
import OfferPage from '@/components/pages/OfferPage'
// import { FAQ } from '@/components/pages/FAQ/FAQ'
// import { PrivacyPolicy } from '@/components/pages/PrivacyPolicy/PrivacyPolicy'
// import { MoneyBackPolicy } from '@/components/pages/MoneyBackPolicy/MoneyBackPolicy'
// import { Terms } from '@/components/pages/Terms/Terms'
import useEdgeGuard from '@/hooks/useEdgeGuard'
import { TABS } from '@/components/TabsList/types'

const App = () => {
  useEdgeGuard()

  return (
    <AuthProvider>
      <Toaster position="top-center" expand={false} richColors closeButton />
      <PopupProvider>
        <Router basename={HOMEPAGE_PATH}>
          <Routes>
            <Route path={ROUTES.HOME} Component={() => <HomePage />} />
            <Route
              path={ROUTES.LOGIN}
              Component={(props) => (
                <RestrictedRoute>
                  <LoginPage {...props} />
                </RestrictedRoute>
              )}
            />
            <Route
              path={ROUTES.OTP}
              Component={(props) => (
                <RestrictedRoute>
                  <OtpPage {...props} />
                </RestrictedRoute>
              )}
            />
            {/* <Route path="/forgot/" Component={(props) => <ForgotPage {...props} />} /> */}
            {/* <Route path="/forgot-success/" Component={(props) => <ForgotSuccessPage {...props} />} /> */}
            <Route
              path={ROUTES.PROFILE}
              Component={(props) => (
                <ProtectedRoute>
                  <ProfilePage {...props} baseTab={TABS.PROFILE} />
                </ProtectedRoute>
              )}
            />
            <Route
              path={ROUTES.SUBSCRIPTIONS}
              Component={(props) => (
                <ProtectedRoute>
                  <ProfilePage {...props} baseTab={TABS.SUBSCRIPTIONS} />
                </ProtectedRoute>
              )}
            />
            <Route
              path={ROUTES.REASONS}
              Component={(props) => (
                <ProtectedRoute>
                  <ReasonsPage {...props} />
                </ProtectedRoute>
              )}
            />

            <Route
              path={ROUTES.OFFER}
              Component={(props) => (
                <ProtectedRoute>
                  <OfferPage {...props} />
                </ProtectedRoute>
              )}
            />
            {/* TODO Remove this links later as a separated task */}
            {/* <Route path={ROUTES.FAQ} Component={(props) => <FAQ {...props} />} /> */}
            {/* <Route */}
            {/*  path={ROUTES.PRIVACY_POLICY} */}
            {/*  Component={(props) => <PrivacyPolicy {...props} />} */}
            {/* /> */}
            {/* <Route path={ROUTES.MONEY_BACK} Component={(props) => <MoneyBackPolicy {...props} />} /> */}
            {/* <Route path={ROUTES.TERMS} Component={(props) => <Terms {...props} />} /> */}
          </Routes>
        </Router>
      </PopupProvider>
    </AuthProvider>
  )
}

export default App
